console.log 'La vida es más que bella, es hermosa'
